import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { getRedirectResult, listenToAuth } from '../redux/actions/auth'
import { listenForPolls } from '../redux/actions/user'
import configureStore from '../redux/store'

export default class AppService {
	constructor() {
		this.store = configureStore()
		this.history = syncHistoryWithStore(browserHistory, this.store)

		this.store.subscribe(() => {
			const { user: newUser } = this.store.getState()
			if (this.user !== newUser) {
				this.user = newUser
				if (this.user) {
					this.store.dispatch(listenForPolls())
				}
			}
		})

		this.store.dispatch(getRedirectResult())
		this.store.dispatch(listenToAuth())
	}
}



// WEBPACK FOOTER //
// ./src/services/AppService.js